// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { ContextStore } from 'bernie-core';

// shared-ui
import { ILocalization, LocalizedText, withLocalization } from '@shared-ui/localization-context';

// ui
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkSubheading, UitkText } from 'uitk-react-text';
import { UitkList, UitkListItem } from 'uitk-react-list';

// mobx
import { Legal } from 'src/models';
import { LegalStore } from '../../stores';
import { UitkLink } from 'uitk-react-link';

export interface PrivacyPolicyProps {
  context?: ContextStore;
  l10n?: ILocalization;
  legal?: LegalStore;
}

export interface PrivacyPolicyState {
  legal?: Legal;
}

@withLocalization
@inject('context', 'legal')
export class PrivacyPolicy extends React.Component<PrivacyPolicyProps, PrivacyPolicyState> {
  constructor(props) {
    super(props);

    const siteId = this.props.context.site.id;
    this.state = {
      legal: this.props.legal.getConfig(siteId),
    };
  }

  public render() {
    const { address, email, supportLink } = this.state.legal;

    return (
      <UitkSpacing className="container--small" padding={{ block: 'twelve' }}>
        <main>
          <UitkHeading tag="h1" size={3}>
            <LocalizedText message="privacy.header" />
          </UitkHeading>
          <UitkSubheading>
            <LocalizedText message="privacy.modified" />
          </UitkSubheading>
          <UitkText spacing="six">
            <LocalizedText message="privacy.intro" />
          </UitkText>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="privacy.section1.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <em>
                  <LocalizedText message="privacy.section1.p1.header" />
                </em>{' '}
                <LocalizedText message="privacy.section1.p1.body" />
              </UitkText>
              <UitkText spacing="four">
                <em>
                  <LocalizedText message="privacy.section1.p2.header" />
                </em>{' '}
                <LocalizedText message="privacy.section1.p2.body" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="privacy.section2.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="privacy.section2.p1" />
              </UitkText>
              <UitkText spacing="two">
                <LocalizedText message="privacy.section2.p2.header" />
              </UitkText>
              <UitkSpacing className="uitk-type-list-400" padding={{ block: 'three', inline: 'four' }}>
                <UitkList>
                  <UitkListItem>
                    <LocalizedText message="privacy.section2.p2.bullet1" />
                  </UitkListItem>
                  <UitkListItem>
                    <LocalizedText message="privacy.section2.p2.bullet2" />
                  </UitkListItem>
                </UitkList>
              </UitkSpacing>
              <UitkText spacing="two">
                <LocalizedText message="privacy.section2.p3.header" />
              </UitkText>
              <UitkSpacing className="uitk-type-list-400" padding={{ block: 'three', inline: 'four' }}>
                <UitkList>
                  <UitkListItem>
                    <LocalizedText message="privacy.section2.p3.bullet1" />
                  </UitkListItem>
                  <UitkListItem>
                    <LocalizedText message="privacy.section2.p3.bullet2" />
                  </UitkListItem>
                  <UitkListItem>
                    <LocalizedText message="privacy.section2.p3.bullet3" />
                  </UitkListItem>
                  <UitkListItem>
                    <LocalizedText message="privacy.section2.p3.bullet4" />
                  </UitkListItem>
                </UitkList>
              </UitkSpacing>
              <UitkText spacing="two">
                <em>
                  <LocalizedText message="privacy.section2.p4.header" />
                </em>{' '}
                <LocalizedText message="privacy.section2.p4.body" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="privacy.section3.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="privacy.section3.p1.label" />
              </UitkText>
              <UitkSpacing className="uitk-type-list-400" padding={{ block: 'three', inline: 'four' }}>
                <UitkList>
                  <UitkListItem>
                    <LocalizedText message="privacy.section3.p1.bullet1" />
                  </UitkListItem>
                  <UitkListItem>
                    <LocalizedText message="privacy.section3.p1.bullet2" />
                  </UitkListItem>
                  <UitkListItem>
                    <LocalizedText message="privacy.section3.p1.bullet3" />
                  </UitkListItem>
                  <UitkListItem>
                    <LocalizedText message="privacy.section3.p1.bullet4" />
                  </UitkListItem>
                  <UitkListItem>
                    <LocalizedText message="privacy.section3.p1.bullet5" />
                  </UitkListItem>
                  <UitkListItem>
                    <LocalizedText message="privacy.section3.p1.bullet6" />
                  </UitkListItem>
                </UitkList>
              </UitkSpacing>
              <UitkText spacing="four">
                <LocalizedText message="privacy.section3.p2" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="privacy.section3.p3" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="privacy.section4.header" />
              </UitkHeading>
              <UitkSpacing className="uitk-type-list-400" padding={{ block: 'three', inline: 'four' }}>
                <UitkList>
                  <UitkListItem className="opt-out-item">
                    <LocalizedText message="privacy.section4.p1" />
                  </UitkListItem>
                  <UitkListItem className="opt-out-item">
                    <LocalizedText message="privacy.section4.p2" />
                  </UitkListItem>
                  <UitkListItem className="opt-out-item">
                    <LocalizedText message="privacy.section4.p3" />
                  </UitkListItem>
                </UitkList>
              </UitkSpacing>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="privacy.section5.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="privacy.section5.p1.label" />
              </UitkText>
              <UitkSpacing className="uitk-type-list-400" padding={{ block: 'three', inline: 'four' }}>
                <UitkList>
                  <UitkListItem>
                    <LocalizedText message="privacy.section5.p1.bullet1" />
                  </UitkListItem>
                  <UitkListItem>
                    <LocalizedText message="privacy.section5.p1.bullet2" />
                  </UitkListItem>
                </UitkList>
              </UitkSpacing>
              <UitkText spacing="four">
                <LocalizedText message="privacy.section5.p2" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="privacy.section5.p3" />{' '}
                <UitkLink inline={true}>
                  <a href={supportLink}>{supportLink}</a>
                </UitkLink>
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="privacy.section5.p4" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="privacy.section6.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="privacy.section6.p1" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="privacy.section7.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="privacy.section7.p1" />{' '}
                <UitkLink inline={true}>
                  <a href={`mailto:${email}`}>{email}</a>
                </UitkLink>
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="privacy.section8.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="privacy.section8.p1" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="privacy.section9.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="privacy.section9.p1" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="privacy.section10.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="privacy.section10.p1" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="privacy.section11.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="privacy.section11.p1" />
                <span>{address}</span>
              </UitkText>
              <UitkText>
                <UitkLink inline={true}>
                  <a href={`mailto:${email}`}>{email}</a>
                </UitkLink>
              </UitkText>
              <UitkText spacing="two">
                <LocalizedText message="privacy.section11.p2" />{' '}
                <UitkLink inline={true}>
                  <a href={supportLink}>{supportLink}</a>
                </UitkLink>
              </UitkText>
            </div>
          </UitkSpacing>
        </main>
      </UitkSpacing>
    );
  }
}
